module.exports = __webpack_public_path__ + "img/loader-huddle.70e99924.gif";